import { Accessory } from '../../models/accessory';
import { productCatalogueHttp } from '../product-catalogue-api';

/**
 * Fetches family accessories for a given family ID and locale.
 *
 * @param familyId - The ID of the family to fetch accessories for.
 * @param locale - The locale to use when fetching data.
 * @returns A promise that resolves to an array of `Accessory`, or `null` if none exist.
 */
export const getFamilyAccessories = async (
  familyId: number,
  locale: string
): Promise<Accessory[] | null> => {
  try {
    const url = `/family/${familyId}/accessories?marketLocale=${encodeURIComponent(locale)}`;
    const response = await productCatalogueHttp.get<Accessory[]>(url);

    return response?.data ?? null;
  } catch (error) {
    console.error(`Failed to fetch family accessories for familyId: ${familyId}`, error);
    return null;
  }
};
